import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConsultarPreguntasService } from 'src/app/administrador-preguntas/consultar-preguntas.service';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-select-annio',
  templateUrl: './select-annio.component.html',
  styleUrls: ['./select-annio.component.css']
})
export class SelectAnnioComponent implements OnInit {
  formAnnio:FormGroup
  anio_actual = new Date().getFullYear();
  listaAnnios=[];
  constructor(private fb:FormBuilder,public router:Router, private globals:Globals,private consultarPreguntas:ConsultarPreguntasService) { }
    loading=false;
  ngOnInit() {
    this.formAnnio=this.fb.group({
      annio:['',Validators.required]
    })

    this.generarListaAnnios();
  }

  enviarAnnio(){
    this.loading=true;
    this.globals.annioSeleccionado=this.formAnnio.value['annio'];
   
    if( this.globals.tipoConsulta=="TodasRespuestas"){
      this.consultarPreguntas.ConsultarConflictoResumenAnnio2(this.globals.funcionarioSeleccionado.idtbl_funcionario, 1,this.formAnnio.value['annio']).subscribe(rt=>{
        this.globals.historialRespuestasSeleccionado=rt;
        this.router.navigate(["/resumenEncuesta"]);
            this.loading=false;
        
      })
    }

    if(this.globals.tipoConsulta=="RespuestaIndividual"){
     
        this.consultarPreguntas.ConsultarConflictoResumenAnnio2(this.globals.funcionarioSeleccionado.idtbl_funcionario, 1,this.formAnnio.value['annio']).subscribe(rt=>{
          this.globals.historialRespuestasSeleccionado=rt;
          console.log(rt)
          this.router.navigate(["/resumenEncuesta"]);
              this.loading=false;
        
        })
      
  
    }
        
    
     
  }

  generarListaAnnios(){
    if(this.globals.tipoConsulta=="TodasRespuestas"){
      for(let i=2021;i<=this.anio_actual;i++){
        this.listaAnnios.push(i)
      }
    }
    else if(this.globals.tipoConsulta=="RespuestaIndividual"){
      for(let i=2021;i<=this.anio_actual;i++){
        this.listaAnnios.push(i)
      }
    }
   
   
  }

  regresar(){
    this.globals.contenedorVarGlobal='preguntas';
  }

}
